import type { LocaleCode } from '@/i18n/locales'
import type { ContactPageLocaleContent } from '../types'
import { contactPageEn } from './en'
import { contactPageEs } from './es'

const contactByLocale: Partial<Record<LocaleCode, ContactPageLocaleContent>> = {
  en: contactPageEn,
  es: contactPageEs,
}

export function getContactPageContent(locale: LocaleCode): ContactPageLocaleContent {
  return contactByLocale[locale] ?? contactPageEn
}
